import { getIconProps, type IconProps } from '#types'

/**
 * Users icon — primary person on the right with a smaller peer figure to
 * the left.
 *
 * Used for user management, member lists, and people sections.
 *
 * @example
 * ```tsx
 * <UsersIcon className="size-5" />
 * ```
 */
export function UsersIcon({ strokeWidth = 1.5, ...props }: IconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 24 24">
      <path
        d="M15 18.75C16.2276 18.75 17.1894 18.7193 17.9443 18.6406C18.7061 18.5613 19.2046 18.4376 19.5342 18.2832C19.8383 18.1407 19.9874 17.9785 20.0801 17.7832C20.1866 17.5586 20.25 17.2234 20.25 16.6875C20.25 16.156 20.1876 15.784 20.0693 15.5107C19.9603 15.259 19.7879 15.0524 19.4795 14.875C18.7909 14.4791 17.4815 14.25 15 14.25C12.5185 14.25 11.2091 14.4791 10.5205 14.875C10.2121 15.0524 10.0397 15.259 9.93066 15.5107C9.81238 15.784 9.75 16.156 9.75 16.6875C9.75 17.2234 9.81345 17.5586 9.91992 17.7832C10.0126 17.9785 10.1617 18.1407 10.4658 18.2832C10.7954 18.4376 11.2939 18.5613 12.0557 18.6406C12.8106 18.7193 13.7724 18.75 15 18.75Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="4"
        cy="4"
        r="3.25"
        transform="matrix(-1 0 0 1 19 4.5)"
        stroke="currentColor"
        strokeWidth={strokeWidth}
      />
      <path
        d="M9 7C7.56 7 6.6 8.22222 6.6 9.44444C6.6 10.6667 7.56 11.8889 9 11.8889M6.3 18C4.06 18 3 17.6944 3 15.8611C3 14.0278 4.28 13.7222 7.8 13.7222"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
